import React, { useEffect, useState } from "react";
import { Card, Form, Offcanvas, Spinner } from "react-bootstrap";
import VerifiedSignature from "../../../img/documentsign.png";
import { useParams } from "react-router";
import Moment from "react-moment";
import Swal from "sweetalert2";
import { studySubjectPrincipleInvestigatorServices } from "../../../APIServices/studySubjectPrincipleInvestigatorServices";
import { BiLockAlt } from "react-icons/bi";

const BulkInvestigatorSignoff = ({ Show, Hide, Title, selectedIds, selectedSiteIds, getSubjectPrincipleInvestigator, statsSubjectPrincipleInvestigator }) => {
  const firstName = JSON.parse(localStorage.getItem("firstName"));
  const lastName = JSON.parse(localStorage.getItem("lastName"));
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [signatureHash, setSignatureHash] = useState("");
  const { studyId } = useParams();
  
  function generateRandomCode(length = 9) {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let result = "";

    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    if (!result || result.length <= 6) return result;
    const start = result.slice(0, 3);
    const end = result.slice(-3);
    const masked = "*".repeat(result.length - 6);
    return start + masked + end;
  }

  useEffect(() => {
    setSignatureHash(generateRandomCode(18))
  }, []);

  const [checkbox, setCheckbox] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [password, setPassword] = useState("");
  const [status, setStatus] = useState("");

  const completeBulkTaskSubjectForPrincipleInvestigator = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Bulk Sign Principle Investigator?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Sign it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true)
        let userData = {}
        userData.studyId = studyId
        userData.siteIds = selectedSiteIds
        userData.reviewIds = selectedIds
        userData.mode = StudyMode
        userData.password = password
        userData.status = status
        let data = await studySubjectPrincipleInvestigatorServices.completeBulkTaskSubjectForPrincipleInvestigator(userData)
        if (data?.statusCode === 200) {
          getSubjectPrincipleInvestigator()
          statsSubjectPrincipleInvestigator()
          setStatus("")
          setPassword("")
          Hide()
        }
        setButtonLoader(false)
      }
    });
  };

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card>
            <Card.Body className="p-0">
              <div className="p-2 border-bottom border-success bg-success-subtle">
                <small className="fw-bold">Signing casebook for Bulk Site Subject</small>
              </div>
              <div className="p-2 lh-1 bg-success-subtle">
                <small style={{ fontSize: 13 }}>
                  By signing, I attest that I have reviewed the data contained
                  in this casebook and that, to the best of my knowledge, it is
                  complete, accurate and authentic. This electronic signature is
                  the legal equivalent of my handwritten signature.
                </small>
              </div>
            </Card.Body>
          </Card>
          <Form.Group className="my-2">
            <Form.Label className="mb-1 fw-bold">Status <abbr className="text-danger">*</abbr></Form.Label>
            <Form.Select value={status} onChange={(e) => setStatus(e.target.value)}>
              <option value="">Select Status</option>
              <option value="completed">Pass Review</option>
              <option value="rejected">Fail Review</option>
            </Form.Select>
          </Form.Group>
          <div className="p-3 border rounded bg-light lh-1 mb-2">
            <small className="fw-bold"><BiLockAlt /> Electronic Signature</small>
            <Form.Label style={{ fontSize: 10 }}>
              Per 21 CFR Part 11, re-enter your password to authorise this
              action.
            </Form.Label>
            <Form.Group className="mb-2">
              <Form.Label className="mb-1 fw-bold">Username</Form.Label>
              <Form.Control disabled value={`${firstName || ""} ${lastName || ""}`} type="text" placeholder="Enter username" />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label className="fw-bold mb-1">
                Password{" "}
                <abbr title="Required" className="text-danger">
                  *
                </abbr>
              </Form.Label>
              <Form.Control
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                className="br3"
                placeholder="Password"
                type="password"
              />
            </Form.Group>
          </div>
          <Form.Group className="mb-2">
            <Form.Label className="mb-1 fw-bold">
              Meaning of Signature
            </Form.Label>
            <Form.Control disabled value="Principle Investigator" type="text" placeholder="Enter" />
          </Form.Group>
          <div className="p-2 border rounded mb-2">
            <div
              className="border border-2 rounded-start border-success border-end-0 position-relative"
              style={{ maxWidth: "fit-content" }}
            >
              <div className="p-3">
                <div className="hstack gap-2">
                  <h6 className="m-0 fw-bold">
                    {firstName}
                    <br />
                    {lastName}
                  </h6>

                  <div>
                    <p
                      className="m-0"
                      style={{ fontSize: 9 }}
                    >
                      Digitally signed by
                      <br />
                      {firstName} {lastName || ""}
                    </p>

                    <p
                      className="m-0"
                      style={{ fontSize: 9 }}
                    >
                      Date:
                      <Moment
                        format="DD/MM/YYYY"
                        withTitle
                      >
                        {new Date()}
                      </Moment>
                      |
                      <br />
                      <Moment
                        format="HH:mm:ss"
                        withTitle
                      >
                        {new Date()}
                      </Moment>
                      - GMT+06:30
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="position-absolute bg-white w-100"
                style={{
                  top: -10,
                  left: 30,
                }}
              >
                <p className="fw-bold m-0 ps-1">
                  eSigned By:
                </p>
              </div>

              <div
                className="position-absolute bg-white w-100"
                style={{
                  bottom: -10,
                  left: 30,
                }}
              >
                <p className="fw-bold m-0 ps-1">
                  {signatureHash}
                </p>
              </div>

              <img
                className="position-absolute"
                style={{
                  top: 8,
                  left: 47,
                  pointerEvents: "none",
                  filter: "opacity(0.2)",
                  width: 70,
                }}
                src={VerifiedSignature}
                alt="Signed"
              />
            </div>
          </div>
          <Form.Check onChange={(e) => setCheckbox(!checkbox)} checked={checkbox} label="I confirm the attestation above and understand this signature is permanent and cannot be removed." />
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm hstack justify-content-end gap-2">
          <button
            disabled={buttonLoader || !status || !password || !checkbox}
            onClick={completeBulkTaskSubjectForPrincipleInvestigator}
            className="updateProfile">
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Signing...
              </div>
            ) : (
              "Sign now"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default BulkInvestigatorSignoff;
